import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingChips.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-regular-svg-icons';

import { getOnboardingStatusChip, getOwnerColorStyle, getOwnerInitials } from './brandOnboardingHelpers';

export const StatusChip = ({ registrationCode }) => {
  const statusChip = getOnboardingStatusChip(registrationCode);
  return <span className={cn('brand-onboarding-status-chip', statusChip.className)}>{statusChip.label}</span>;
};

StatusChip.propTypes = {
  registrationCode: PropTypes.object.isRequired
};

export const CodeChip = ({ code, onCopy, href }) => (
  <>
    {href ? (
      <a className='brand-onboarding-code-chip' href={href} target='_blank' rel='noopener noreferrer'>
        {code}
      </a>
    ) : (
      <span className='brand-onboarding-code-chip'>{code}</span>
    )}
    {onCopy && (
      <FontAwesomeIcon
        icon={faCopy}
        className='brand-onboarding-copy-icon'
        onClick={e => {
          e.stopPropagation();
          onCopy();
        }}
      />
    )}
  </>
);

CodeChip.propTypes = {
  code: PropTypes.string.isRequired,
  onCopy: PropTypes.func,
  href: PropTypes.string
};

export const OwnerChip = ({ userId, name, isKnown, title, onClick }) => (
  <div className='brand-onboarding-owner' title={title} onClick={onClick}>
    <div className={cn('brand-onboarding-owner-avatar', { unknown: !isKnown })} style={isKnown ? getOwnerColorStyle(userId) : undefined}>
      {isKnown ? getOwnerInitials(name) : '?'}
    </div>
    <span className='brand-onboarding-owner-name'>{name}</span>
  </div>
);

OwnerChip.propTypes = {
  userId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  isKnown: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onClick: PropTypes.func
};
